import { getIsEditMode } from 'modules/templateEditor/common';
import { useEditableFieldsContext } from 'modules/templateEditor/context/EditableFieldsContext';
import { useQueryParamContext } from 'modules/templateEditor/context/QueryParamContext';
import { NegativeFill, OpenNewWindow16 } from 'ui/icons';
import { colors } from 'ui/theme';
import { IS_VALID_URL } from 'utils/validationRegex';
import { EmptyInput, ReadOnlyField, formatLabelForId } from '../../../EditEmbedded/utils';
import { InputFieldRow, StyledInputText, StyledLink } from './styles';

type Props = {
  label: string;
  value: string;
  setValue: (value: string) => void;
  hasError?: boolean;
  onDelete?: () => void;
  placeholder?: string;
};

export const MAX_HEADER_TEXT_LENGTH = 60;

export const InputTextField = ({ label, value, setValue, hasError, placeholder }: Props) => {
  const isInputUrl = IS_VALID_URL.test(value);

  const { view } = useQueryParamContext();
  const { isEditMode } = useEditableFieldsContext();
  const isEditModeVisible = getIsEditMode(view, isEditMode);

  const ReadOnlyValue = () =>
    isInputUrl ? (
      <StyledLink href={value} target="_blank">
        <span>{value}</span>
        <OpenNewWindow16 isColorInherited />
      </StyledLink>
    ) : (
      <ReadOnlyField>
        {hasError && <NegativeFill color={colors.negative100} />}
        {value}
      </ReadOnlyField>
    );

  return (
    <>
      {isEditModeVisible ? (
        <InputFieldRow>
          <StyledInputText
            maxLength={MAX_HEADER_TEXT_LENGTH}
            data-test={`${formatLabelForId(label)}-input`}
            hasError={hasError}
            onChange={setValue}
            placeholder={placeholder}
            value={value}
          />
        </InputFieldRow>
      ) : (
        <>
          {value ? (
            <ReadOnlyValue />
          ) : (
            <ReadOnlyField>
              <EmptyInput />
            </ReadOnlyField>
          )}
        </>
      )}
    </>
  );
};
